"use client";
import React, { Component, ErrorInfo, ReactNode } from "react";

export class GameErrorBoundary extends Component<{ children: ReactNode }, { hasError: boolean, errorInfo: any }> {
    constructor(props: { children: ReactNode }) {
        super(props);
        this.state = { hasError: false, errorInfo: null };
    }

    static getDerivedStateFromError(error: Error) {
        return { hasError: true, errorInfo: error };
    }

    componentDidCatch(error: Error, errorInfo: ErrorInfo) {
        console.error("ErrorBoundary caught:", error, errorInfo);
    }

    render() {
        if (this.state.hasError) {
            return (
                <div style={{ padding: 20, background: 'red', color: 'white' }}>
                    <h2>React crashed!</h2>
                    <pre style={{ whiteSpace: 'pre-wrap', fontSize: '12px' }}>
                        {this.state.errorInfo?.message || String(this.state.errorInfo)}
                    </pre>
                </div>
            );
        }
        return this.props.children;
    }
}
